import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { tomos } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-white py-16 md:py-24" data-id="element-248" data-mp="101dix2netffd">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-249" data-mp="l44o1yywdtiw">
        <header className="mx-auto max-w-narrow text-center" data-id="element-250" data-mp="l5pfvgttuyd2">
          <p className="inline-flex items-center gap-2 rounded-full bg-blue-900 px-5 py-2 font-display text-xs font-extrabold uppercase tracking-[0.16em] text-gold-300" data-id="element-251" data-mp="q2y2btm0dok4">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="1ird61jzowkg5" />
            Los 6 tomos principales
          </p>

          <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-253" data-mp="141flrf4vsew8">
            Lo que obtenés:
            <br data-id="element-254" data-mp="1wquyqag3whus" />
            <span className="text-gold-600" data-id="element-255" data-mp="1wqcrkirwoj83">6 Tomos + 6 Bonos</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg text-blue-900/75 md:text-xl" data-id="element-256" data-mp="21hl5ns46ksrl">
            Todo está listo. Sin armarlo. Sin pensar. Solo empezar.
          </p>
        </header>

        <ol className="mx-auto mt-12 max-w-narrow divide-y divide-blue-100 overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-blue-100 md:mt-16" data-id="element-257" data-mp="2vdhgfn59ml3w">
          {tomos.map(tomo => <li key={tomo.number} className="flex gap-5 px-5 py-6 md:px-8" data-id="element-258" data-mp="357q8yauaqe22">
              <span className={`flex h-14 w-11 shrink-0 items-end justify-center rounded-md pb-1.5 font-display text-xs font-extrabold text-gold-300 ${tomo.spine}`} aria-hidden="true" data-id="element-259" data-mp="30dc99w8lpkrl">
                {tomo.number}
              </span>
              <span data-id="element-260" data-mp="3o3gbq0a1zeh0">
                <span className="block font-display text-xs font-extrabold uppercase tracking-[0.16em] text-gold-600" data-id="element-261" data-mp="3o3q2vr6u3roa">
                  Tomo {tomo.number} — {tomo.short}
                </span>
                <span className="mt-1.5 block font-display text-lg font-extrabold leading-snug tracking-tight text-ink md:text-xl" data-id="element-262" data-mp="1tr06n2szu6dq">
                  {tomo.title}
                </span>
                <span className="mt-2 block text-blue-900/75" data-id="element-263" data-mp="2egudhswkpiav">{tomo.detail}</span>
              </span>
            </li>)}
        </ol>
      </div>
    </section>;
}